const SectionObserver = () => {
  const triggers = [...document.querySelectorAll('.nav__menu a')];
  const targets = [...document.querySelectorAll('.section')];
  const activeClass = 'active';
  let targetRatios = {};
  let clickPrevTrigger;
  let clickTargetId;
  
  const IntersectionObserverOptions = {
    root: null,
    rootMargin: '0px',
    threshold: thresholdArray(10)
  };
  
  triggers.forEach(trigger => trigger.addEventListener('click', handleTriggerClick));
  
  function handleTriggerClick(e) {
    const prevTrigger = triggers.find(trigger => trigger.classList.contains(activeClass));
    const nextTrigger = e.target;
    clickPrevTrigger = prevTrigger;
    clickTargetId = nextTrigger.hash;
    switchActive(prevTrigger, nextTrigger);
  }

  function callback(entries) {
    entries.forEach(entry => {
      targetRatios[entry.target.id] = entry.intersectionRatio;
    });

    const ratios = Object.values(targetRatios);
    const targetId = '#' + getKeyByValue(targetRatios, Math.max(...ratios));
    const prevTrigger = clickPrevTrigger || triggers.find(trigger => trigger.classList.contains(activeClass));
    const nextTrigger = triggers.find(trigger => trigger.hash === targetId);

    if (clickPrevTrigger && targetId !== clickTargetId) return;
    if (prevTrigger === nextTrigger) return;

    switchActive(prevTrigger, nextTrigger);

    clickPrevTrigger = null;
  }

  const observer = new IntersectionObserver(callback, IntersectionObserverOptions);
  targets.forEach(target => {
    observer.observe(target);
  });
  
  function switchActive(prev, next) {
    if (prev) {
      prev.classList.remove(activeClass);
    }
    if (next) {
      next.classList.add(activeClass);
    }
  }

  function thresholdArray(steps) {
    return Array(steps + 1)
      .fill(0)
      .map((_, index) => index / steps || 0);
  }

  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }
}

export default SectionObserver;
